import { ICalibrationChangelog } from '@models/calibrations/calibration-changelog';
import { ICalibrationComment } from '@models/calibrations/calibration-comment';
import { CalibrationStatus } from '@models/record-status';

export interface ICalibration {
  CalibrationId?: number;
  ChangeLogs?: ICalibrationChangelog<ICalibration>[];
  Comment?: string;
  Comments?: ICalibrationComment[];
  FormId?: string;
  ProductId?: number;
  RecordStatus?: CalibrationStatus;
  UserIdCreated?: number;
  UserIdModified?: number;
}

// Should match DB CalibrationTypeId
export enum CALIBRATION_TYPES {
  Beta = 1,
  Decay = 2,
  StableBalance = 3
}
